import { LocalizeNumberOptions, useLocalizeNumber } from './useLocalizeNumber';

interface LocalizedNumberProps {
    value: number;
    options?: LocalizeNumberOptions;
}

export const NewLocalizedNumber = ({ value, options }: LocalizedNumberProps) => {
    const localizeNumber = useLocalizeNumber();
    return <>{localizeNumber(value, options)}</>;
};
